// import { cloneDeep } from "lodash";

const initialState = {
    profileData: {},
    quizdata: {},
    bankDetails: {},
    bankDetailsError: {},
    ifscDetails: {},
    toggleStatus: false,
    toggleAlertStatus: false,
    errMsg: '',
    duration: 2000,
    color: 'bg-moon-gray',
    component: undefined,
    dismiss: true,
    redeemData: {},
    withdrawres: {},
    linkdata: {},
    cancleWithdrawRes: {},
    transcationsdata: {},
    deleteWallet: {},
    wallettypedata: {},
    redeemhistory: {},
    upidata: {},
    removeupiData: {},
    failedTranscations: {},
    rechecktranscation: {},
    delinkBankAccount: {},
    bonusSummery: {},
    networkStatus: "connected",
    tpslrechecktranscation: {},
    razorpayrecheckData: {},
    tdsInfoResponse: {},
    pokerToA23TransferRes: {},
    a23ToPokerTransferRes: {},
    appHidden: false,
    redeemAcePointsDetails:{
        // redeem data
        claimSuccessMessage:""
    }
}


export const reducer = (state = initialState, action) => {
    // console.log("actiontype",action.type);
    // console.log("A23 TO POKER - 3",action.payload ,action);

    switch (action.type) {
        case "profile_data":
            return {
                ...state,
                profileData: action.payload
            }
        case "profile_error":
            return {
                ...state,
                profileData: action.payload
            }
        case "Quiz_data":
            return {
                ...state,
                quizdata: action.payload
            }

        case "BANK_DATA":
            return {
                ...state,
                bankDetails: action.payload

            }
        case "BANK_DATA_ERROR":
            return {
                ...state,
                bankDetailsError: action.payload

            }
        case "IFSC_ERROR":
            return {
                ...state,
                ifscDetails: action.payload
            }
        case "IFSC_DATA":
            return {
                ...state,
                ifscDetails: action.payload
            }
        case "TOGGLE_ALERT":
            return {
                ...state,
                toggleAlertStatus: action.payload.toggleAlertStatus,
                errMsg: typeof action.payload.errMsg === 'undefined' ? state.errMsg : action.payload.errMsg,
                duration: typeof action.payload.duration === 'undefined' ? 3200 : action.payload.duration,
                color: typeof action.payload.color === 'undefined' ? 'bg-light-red' : action.payload.color,
            };
        case "TOGGLE_MODAL":
            return {
                ...state,
                toggleStatus: action.payload.toggleStatus,
                component: action.payload.component,
                dismiss: typeof action.payload.dismiss === "undefined" ? true : action.payload.dismiss
            };
        case "redeem_error":
            return {
                ...state,
                redeemData: action.payload
            }
        case "redeem_data":
            return {
                ...state,
                redeemData: action.payload
            }
        case "withdraw_data":
            return {
                ...state,
                withdrawres: action.payload
            }
        case "link_data":
            return {
                ...state,
                linkdata: action.payload
            }
        case "cancle_withdraw_data":
            return {
                ...state,
                cancleWithdrawRes: action.payload
            }
        case "transcations_data":
            return {
                ...state,
                transcationsdata: action.payload
            }
        case "delete_wallet":
            return {
                ...state,
                deleteWallet: action.payload
            }
        case "wallet_type_data":
            console.log("WALLET TYPE INFO DATA FROM REDUCER", action.payload);
            return {
                ...state,
                wallettypedata: action.payload
            }
        case "redeem_history":
            return {
                ...state,
                redeemhistory: action.payload
            }
        case "upi_data":
            return {
                ...state,
                upidata: action.payload
            }
        case "remove_upi":
            return {
                ...state,
                removeupiData: action.payload
            }
        case "failed_transcations_history":
            return {
                ...state,
                failedTranscations: action.payload
            }
        case "recheck_transcation":
            return {
                ...state,
                rechecktranscation: action.payload
            }

        case "delink_bankAccount":
            return {
                ...state,
                delinkBankAccount: action.payload
            }

        case "bonus_summery":
            return {
                ...state,
                bonusSummery: action.payload
            }

        case "network_status":
            return {
                ...state,
                networkStatus: action.networkStatus
            }

        case "UPDATE_VISIBILITY":
            console.log("APP VISIBILITY REDUCER: ", action.appHidden)
            return {
                ...state,
                appHidden: action.appHidden
            }

        case "tpsl_recheck_transcation":
            return {
                ...state,
                tpslrechecktranscation: action.payload
            }
        case "a23ToPoker":
            return {
                ...state,
                a23ToPokerTransferRes: action.payload
            }
        case "pokerToA23":
            return {
                ...state,
                pokerToA23TransferRes: action.payload
            }
        case "tds_info":
            return {
                ...state,
                tdsInfoResponse: action.payload
            }
        case "razorpay_recheck_transcation":
            return {
                ...state,
                razorpayrecheckData: action.payload
            }
        case "redeem_ace_points_details":
            return {
                ...state,
                redeemAcePointsDetails:{
                    ...action.payload,
                    claimSuccessMessage:state.redeemAcePointsDetails.claimSuccessMessage
                }
            }
        case "redeem_ace_points_claim_success":
            return {
                ...state,
                redeemAcePointsDetails:{
                    ...state.redeemAcePointsDetails,
                    claimSuccessMessage:action.payload
                }
            }

        default:
            return state
    }
}